import { i18nDispatcherOnlineDispatching } from 'models/i18n';

const skDispatcherOnlineDispatching: i18nDispatcherOnlineDispatching = {
  title: 'Online dispečing',
  balanceGroupImbalance: {
    title: 'Odchýlka bilančnej skupiny',
    plannedImbalanceD1: 'Plánovaná odchýlka D+1',
    plannedImbalanceHX: 'Plánovaná odchýlka H+X',
    actualImbalance: 'Aktuálna odchýlka'
  },
  systemValues: {
    title: 'Systémové veličiny',
    system: 'sústava',
    price: 'nacenenie',
    predictedPriceIDM15: 'Predikovaná cena IDM15',
    predictedPriceIDM60: 'Predikovaná cena IDM60',
    predictedSystemImbalance: 'Predikovaná odchýlka sústavy',
    systemImbalance: 'Aktuálna odchýlka sústavy',
    actualSystemImbalance: 'Aktuálna odchýlka sústavy'
  },
  productionPlan: {
    title: 'Plán produkcie',
    plannedProduction: 'Plán produkcie',
    predictedProduction: 'Predikovaný plán produkcie',
    actualProduction: 'Aktuálna produkcia'
  },
  overviewTable: {
    title: 'Prehľad odberných miest a zariadení ',
    periodText: ' obchodná perióda',
    input: {
      Filter: 'Odberné miesta',
      DeliveryPoints: 'Odberné miesta',
      BalancingGroups: 'Bilančné skupiny'
    },
    columns: {
      deliveryPointName: 'Názov odberného miesta',
      deviceName: 'Názov zariadenia',
      communicationStatus: 'Stav komunikácie',
      actualProduction: 'Aktuálna produkcia',
      plannedProduction: 'Plán produkcie',
      productionFulfillment: 'Úroveň naplnenia plánu',
      actions: 'Akcie'
    }
  },
  deliveryPoint: {
    periodText: ' obchodná perióda',
    systemValuesState: {
      heartbeat: 'Stav komunikácie',
      heartbeatLastUpdate: 'Posledná aktualizácia',
      operationEvent: 'Režim ovládania OOM',
      centreBreakDisconnectorStatus: 'Stav prípojnicového odpojovača',
      fuseCarrierStatus: 'Stav poistkového odpojovača',
      outputBreakerStatus: 'Stav vývodového odpojovača',
      powerSwitchStatus: 'Stav výkonového vypínača',
      groundingStatus: 'Stav zemniča',
      hrmStatus: 'Stav HRM',
      activeEnergyTotalSupply: 'Celková dodávka',
      activeEnergyTotalOfftake: 'Celkový odber',
      sourceType: {
        FIELD: 'Pole',
        DIST: 'Distribučná stanica',
        DPOINT: 'Odberné miesto'
      }
    },
    operationEvents: { title: 'Prevádzkové udalosti' },
    currentPhases: {
      title: 'Merané veličiny',
      current: {
        title: 'Prúd',
        currentPhase1: 'Prúd vo fáze IL1',
        currentPhase2: 'Prúd vo fáze IL2',
        currentPhase3: 'Prúd vo fáze IL3'
      },
      voltage: {
        title: 'Napätie',
        voltagePhase1: 'Napätie vo fáze L1',
        voltagePhase2: 'Napätie vo fáze L2',
        voltagePhase3: 'Napätie vo fáze L3'
      },
      power: {
        title: 'Výkon',
        cosPhi: 'Účinník',
        frequency: 'Frekvencia',
        activePower: 'Výkon'
      }
    }
  },
  device: {
    deviceParameters: {
      stateOfCharge: 'Stav nabitia batérie',
      activeEnergySupply: 'Dodávka v akt. perióde',
      activeEnergyOfftake: 'Odber v akt. perióde',
      phaseElementStatus: 'Stav fázovacieho prvku',
      activeEnergyTotalSupply: 'Celková dodávka',
      activeEnergyTotalOfftake: 'Celkový odber',
      deviceControlMode: 'Režim riadenia zdroja',
      dcVoltage: 'Jednosmerné napätie panelov',
      dcCurrent: 'Jednosmerný prúd panelov',
      deviceEfficiency: 'Účinnosť',
      requestedPower: 'Žiadaná hodnota činného výkonu',
      activePower: 'Činný výkon +/-P',
      reactivePower: 'Jalový výkon +/-Q',
      tankFillLevel: 'Naplnenie zásobníka',
      lowerWaterLevel: 'Výška dolnej hladiny',
      upperWaterLevel: 'Výška hornej hladiny',
      turbineWaterFlow: 'Turbínový prietok',
      passiveWaterFlow: 'Jalový prietok'
    },
    deviceControlMode: {
      max_power: 'MPPT',
      requested_power: ' Žiadaný výkon'
    },
    activeAndReactivePowerProgress: {
      title: 'Priebeh činného a jalového výkonu',
      activePower: 'Činný výkon',
      reactivePower: 'Jalový výkon',
      activeRequestedPower: 'Žiadaná hodnota činného výkonu'
    }
  }
};

export default skDispatcherOnlineDispatching;
